import { Button, Divider, Icon, Input } from "@ui-kitten/components";
import React, { useState } from "react";
import { View } from "react-native";
import { Option } from "../../common/autocomplete";
import { MixerFlavorCreatableAutocomplete } from "./MixerFlavorCreatableAutocomplete";

export interface MixerIngredientFormValues {
    _id: string;
    percentage?: number;
    flavor?: Option;
}

interface MixerIngredientFormProps {
    values: MixerIngredientFormValues;
    onChange: (values: MixerIngredientFormValues) => void;
    onRemove: () => void;
}
let timer: NodeJS.Timer | null = null;

export const MixerIngredientForm: React.FC<MixerIngredientFormProps> = ({ values, onChange, onRemove }) => {
    const handleChange = (key: keyof MixerIngredientFormValues, value: any) => {
        let prevValues: MixerIngredientFormValues;
        setInternalValues((prev) => {
            prevValues = prev;
            return {
                ...prev,
                [key]: value
            };
        });
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            if (key === "percentage") {
                value = +value;
                if (typeof value !== "number" || Number.isNaN(value) || value > 100) {
                    setInternalValues({ ...prevValues });
                    return;
                }
            }
            onChange({
                ...values,
                [key]: value,
            });
        }, 500);
    };

    const [internalValues, setInternalValues] = useState<MixerIngredientFormValues>({
        ...values
    });

    return (
        <View style={{ flexDirection: "row", alignItems: "center" }}>
            <View style={{ flex: 5, marginRight: 16 }}>
                <MixerFlavorCreatableAutocomplete
                    onSelectFlavor={(flavor) => handleChange("flavor", flavor)}
                    selectedFlavorOption={internalValues.flavor}
                />
            </View>
            <View style={{ flex: 1 }}>
                <Input
                    value={internalValues.percentage ? internalValues.percentage.toString() : ""}
                    onChangeText={(text) => handleChange("percentage", text)}
                    style={{ flex: 1 }}
                />
            </View>
            <View style={{ width: 32 }}>
                <Button
                    style={{ width: 32 }}
                    onPress={onRemove}
                    appearance="ghost"
                    status="basic"
                    size="tiny"
                    accessoryLeft={(props) => <Icon name="trash-outline" {...props} />}
                />
            </View>
            <Divider />
        </View>
    );
};
